import { Routes } from '@/lib/routes';

interface NavigateWithSafeBackOptions {
  back: () => void;
  fallback?: string;
  navigate: (to: string) => void;
}

export function navigateWithSafeBack({
  back,
  fallback = Routes.Root,
  navigate,
}: NavigateWithSafeBackOptions) {
  if (canUseBrowserBack()) {
    back();
    return;
  }

  navigate(fallback);
}

function canUseBrowserBack() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  const referrer = document.referrer;
  if (!referrer) return false;

  try {
    return (
      new URL(referrer, window.location.href).origin === window.location.origin
    );
  } catch {
    return false;
  }
}
